import { Injectable } from "@angular/core";



import { catchError, Observable, throwError } from "rxjs";
import { Org } from "../../models/org";
import { environment } from "../../../environments/environment";
import { ACCESS_TOKEN } from '../../storage/constants.lib';
import { HttpClient, HttpHeaders } from "@angular/common/http";



@Injectable({
  providedIn: "root"
})
export class PictureService {



  public baseURL = environment.baseURL;



  constructor(
    private http: HttpClient,
  ) {

  }


  getSites = (): Observable<Org[]> => {
    const token = localStorage.getItem(ACCESS_TOKEN)
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);

    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<Org[]>(`${this.baseURL}/api/org/getall`, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }




  deleteSite(siteId: string): Observable<Org[]> {
    const token = localStorage.getItem(ACCESS_TOKEN)
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<Org[]>(`${this.baseURL}/api/org/delete/${siteId}`, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );

  }

  disableSite(siteId: string): Observable<Org[]> {
    const token = localStorage.getItem(ACCESS_TOKEN)
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<Org[]>(`${this.baseURL}/api/org/disable/${siteId}`, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );

  }

  changePaymentStatus(siteId: string, paymentStatus: number): Observable<Org[]> {
    const token = localStorage.getItem(ACCESS_TOKEN)
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<Org[]>(`${this.baseURL}/api/org/payment/${siteId}/${paymentStatus}`, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );

  }

  enableSite(siteId: string): Observable<Org[]> {
    const token = localStorage.getItem(ACCESS_TOKEN)
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get<Org[]>(`${this.baseURL}/api/org/enable/${siteId}`, httpOptions)
      .pipe(
        catchError((error: Response) => this.handleError(error))
      );

  }

  switchSite(siteId: string): Observable<any> {
    const token = localStorage.getItem('access_token')
    let headers = new HttpHeaders();
    //headers.append("Content-Type", 'application/json');
    headers = headers.append("Authorization", 'Bearer ' + token);
    const httpOptions = {
      headers: headers
    };
    return this.http
      .get(`${this.baseURL}/api/user/switch/${siteId}`, httpOptions)

      .pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }



  addDataset(strData: string): Observable<any> {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers
    };
    return this.http.post(this.baseURL + "/api/datasets/add/", { Name: strData, ID: "", user: "" }, httpOptions).pipe(
        catchError((error: Response) => this.handleError(error))
      );
  }

  private handleError(error: Response) {
      console.error(error);
  
      if (error.status === 401) {
        return throwError(() => new Error("Unauthorized"));
      }
  
      // Add more status-based error handling here if needed
  
      return throwError(() => new Error("Server error"));
    }
}
